export interface AgentInputFieldBase {
  label: string;
  variable: string;
  required: boolean;
  default_var?: string;
  type?: string;
}

export interface AgentTextInputField extends AgentInputFieldBase {
  max_length?: number;
}

export interface AgentSelectField extends AgentInputFieldBase {
  options: string[];
}

export interface AgentInputFormItem {
  'text-input'?: AgentTextInputField;
  text_input?: AgentTextInputField;
  select?: AgentSelectField;
  paragraph?: AgentInputFieldBase;
}

/**
 * AgentInputFormItem에서 type과 field 정보를 추출
 */
export const getAgentInputField = (
  item: AgentInputFormItem,
): { type: 'text-input' | 'select' | 'paragraph'; field: AgentInputFieldBase } | null => {
  const textInput = item['text-input'] ?? item.text_input;
  if (textInput) return { type: 'text-input', field: textInput };
  if (item.select) return { type: 'select', field: item.select };
  if (item.paragraph) return { type: 'paragraph', field: item.paragraph };
  return null;
};

/**
 * 필수 입력값이 모두 채워졌는지 검증
 */
export const hasRequiredAgentInputs = (form: AgentInputFormItem[], values: Record<string, string>): boolean => {
  if (!form.length) return true;
  return form.every((fi) => {
    const r = getAgentInputField(fi);
    if (!r || !r.field.required) return true;
    return !!values[r.field.variable]?.trim();
  });
};

/** {{key}} 패턴을 입력값으로 치환 */
export const substituteAgentInputVariables = (
  text: string | undefined,
  values: Record<string, string>,
): string | undefined => {
  if (!text) return text;
  return text.replace(/\{\{(\w+)\}\}/g, (_, key: string) => values[key] ?? `{{${key}}}`);
};
